/* What a My Library card shows (same look as the new video pages). */

/**
 * Cover pictures: four for a mosaic when the playlist has at least four, else its first, else none (the page then
 * shows a cover in the network colour). The playlist's own thumbnails first, else its videos' pictures.
 */
export function libraryCover(playList: any): string[] {
  const own = (playList?.thumbnails || []).map((t: any) => t?.thumbnail);
  const videos = (playList?.stream_files || []).map((f: any) => f?.stream_info?.video_thumbnail_image || f?.stream_info?.video_banner_image);
  const images = [...new Set<string>([...own, ...videos].filter((src: any) => !!src))];
  if (images.length >= 4) return images.slice(0, 4);
  return images.slice(0, 1);
}

/** Back from My Library: the profile page of the user dashboard (network level only). */
export function libraryBackUrl(channelName: string): string {
  return channelName ? `/${channelName}/user-dashboard/profile-settings/basic-info` : '/user-dashboard/profile-settings/basic-info';
}

/** First letter or digit of the name, for a cover without pictures ("#" when there is none). */
export function libraryInitial(name: string): string {
  const match = String(name || '').match(/[\p{L}\p{N}]/u);
  return match ? match[0].toUpperCase() : '#';
}

/** "1 video", "12 songs"; '' when empty. */
export function libraryCountLabel(playList: any): string {
  const count = (playList?.stream_ids || []).length;
  if (!count) return '';
  const noun = playList?.playlist_type == 'audio' ? 'song' : 'video';
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
